<script setup lang="ts">
    import { IWidget } from '@/js/services/api/widget/types';

    interface Props {
        widget: IWidget<'Prompt'>;
    }

    const props = defineProps<Props>();
</script>
<template>
    <div class="w-full h-full flex items-center justify-center">
        <div class="max-h-full max-w-3/4 overflow-y-hidden">
            <!-- eslint-disable-next-line vue/no-v-html -- trusted backend content -->
            <p class="text-center" v-html="props.widget.promptWidget?.promptText" />
        </div>
    </div>
</template>
